import React, {Component} from 'react';
import { parseClasses } from '../../lib/ep.js';

class Infinite extends Component {
	constructor(props) {
		super(props);
		this.state = {
			page:2,
			hasMore:true,
			fetching:false,
		}
		this.documentScroll = (props.scroll_on_document != undefined) ? props.scroll_on_document : false;
	}

	getElement () {
		let element = this.refs.container;

		if (this.documentScroll) {

			if (this.props.no_ep != undefined) {
				element = $(document)[0];
			}
			else {
				element = document.getElementById('ep-contents') != undefined ? document.getElementById('ep-contents') : $(document)[0]
			}
		}
		return element;
	}

	componentDidMount() {
		//let element = (!this.documentScroll) ? this.refs.container : $(document)[0];
		//let element = (!this.documentScroll) ? this.refs.container : (document.getElementById('ep-contents') != undefined ? document.getElementById('ep-contents') : $(document)[0]);
		let element = this.getElement();
		element.addEventListener('scroll', this.onScroll, false);
	}

	componentWillUnmount() {
		//let element = (!this.documentScroll) ? this.refs.container : $(document)[0];
		//let element = (!this.documentScroll) ? this.refs.container : (document.getElementById('ep-contents') != undefined ? document.getElementById('ep-contents') : $(document)[0]);
		let element = this.getElement();
		element.removeEventListener('scroll', this.onScroll, false);
	}

	reset = () => {
		this.setState({page:2,hasMore:true});
	}

	onScroll = () => {
		if(!this.state.hasMore) return;

		let element = this.refs.container;
		if(this.documentScroll) element = $(document);

		let offset = 400;

		const scroll_top = (!this.documentScroll) ? element.scrollTop : element.scrollTop();
		const scroller_element_height = (!this.documentScroll) ? element.clientHeight : window.innerHeight;
		const total_to_scroll_height = (!this.documentScroll) ? element.scrollHeight : element.height();

		if(!this.state.fetching && ((scroll_top + scroller_element_height + offset) > total_to_scroll_height)) {
			this.setState({fetching:true});
			this.props.fetch(this.state.page,this.fetched.bind(this));
		}
	}

	fetched(data) {
		this.props.fetched(data.data);
		this.state.page++;
		this.state.fetching = false;

		if(!data.hasMore) this.state.hasMore = false;

		this.setState({...this.state});
	}

	render() {
		const maxHeight = (this.props._maxHeight != undefined) ? this.props._maxHeight : {};

		var classname = (this.props.classname != undefined) ? this.props.classname : 'gui_infinite_scroll gui_overflowable';
		classname = parseClasses(classname, this.props._class, 'scrollable');

		return (
			<div class={classname} ref="container" style={maxHeight}>
				{this.props.children}
			</div>
		);
	}
}

export default Infinite;